import { render, staticRenderFns } from "./activity-questions.vue?vue&type=template&id=ed912508&scoped=true&"
import script from "./activity-questions.vue?vue&type=script&lang=js&"
export * from "./activity-questions.vue?vue&type=script&lang=js&"
import style0 from "./activity-questions.vue?vue&type=style&index=0&id=ed912508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed912508",
  null
  
)

component.options.__file = "activity-questions.vue"
export default component.exports